import React from 'react';

import logo from '../assets/images/ib-logo.jpeg'

import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';


const Home = () => (
    <Container fluid id='home' className="p-3 ">
        <Row className='my-4'>
            <Col xs={4}>
                <Image className='p-5' src={logo} fluid/>
            </Col>
            <Col xs={8} className='d-flex justify-content-center'>
                <h1 className='align-self-center'>Mobile Identity, RCS & IoT testing ground</h1>
            </Col>
        </Row>
        <Row className='my-4'>
            <Col className='text-center '>
                <p>Welcome to Solution Engineering home page!</p>
                <Button className='my-4' variant='primary' size='lg' href='/admin'> Admin dashboard</Button>
                
            </Col>
        </Row>
        <Row className='my-4'>
            <Col className='text-center '>
                <h4 >Contact: solution_engineering@infobip.com</h4>
            </Col>
        </Row>

    </Container>
);

export default Home;